// src/components/PrivateRoute.tsx
import React, { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate("/Login");
    }
  }, [authLoading, isAuthenticated, navigate]);

  if (authLoading) return null;
  return isAuthenticated ? <>{children}</> : null;
};

export default PrivateRoute;
